import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import axiosInstance from '../api/axiosInstance';
import socket from '../utils/WebSocket';
import '../styles/notifications.css';

const Notifications = () => {
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [friendRequests, setFriendRequests] = useState({});

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await axiosInstance.get('/notifications/get');
        setNotifications(response.data.data);
        setUnreadCount(response.data.data.filter((n) => !n.is_read).length);

        response.data.data.forEach(async (notification) => {
          if (notification.notification_text.includes("sent you a close friends request")) {
            await checkFriendRequestStatus(notification.entity_id);
          }
        });
      } catch (error) {
        console.error('Error fetching notifications:', error);
      }
    };

    fetchNotifications();

    socket.on('notification', (newNotification) => {
      setNotifications((prev) => [newNotification, ...prev]);
      setUnreadCount((prev) => prev + 1);

      if (newNotification.notification_text.includes("sent you a close friends request")) {
        checkFriendRequestStatus(newNotification.entity_id);
      }
    });

    return () => {
      socket.off('notification');
    };
  }, []);

  const markAsRead = async (notificationId, tableName, entity_id, sender_id) => {
    try {
      await axiosInstance.patch(`/notifications/${notificationId}`);
      setNotifications((prev) =>
        prev.map((n) =>
          n.notification_id === notificationId ? { ...n, is_read: true } : n
        )
      );
      setUnreadCount((prev) => Math.max(0, prev - 1));

      if(tableName == 'user_ratings') {
        navigate(`/profile/${sender_id}`);
      }
      else if(tableName.includes('flash')) {
        navigate(`/flash/${entity_id}`)
      }

    } catch (error) {
      console.error('Error marking notification as read:', error);
    }
  };

  const checkFriendRequestStatus = async (entity_id) => {
    try {
      const response = await axiosInstance.get(`/user-ratings/${entity_id}`);
      console.log(response);
      if (response.data.status === "pending") {
        setFriendRequests((prev) => ({ ...prev, [entity_id]: "pending" }));
      }
    } catch (error) {
      console.error("Error checking friend request status:", error);
    }
  };

  const handleResponse = async (entity_id, status) => {
    try {
      await axiosInstance.patch(`/user-ratings/${entity_id}`, { status });
      
      setFriendRequests((prev) => ({ ...prev, [entity_id]: status }));

      setNotifications((prev) =>
        prev.map((n) =>
          n.entity_id === entity_id ? { ...n, is_read: true } : n
        )
      );
      setUnreadCount((prev) => Math.max(0, prev - 1));
    } catch (error) {
      console.error("Error updating friend request status:", error);
    }
  };

  return (
    <div className="notifications-container">
      <div className="top-header">
        <button className="back-button" onClick={() => navigate(-1)}>
          <i className="fas fa-arrow-left"></i>
        </button>
        <h1 className="top-title">Notifications</h1>
      </div>

      <div className="notifications-header">
        {unreadCount > 0 && (
          <span className="unread-count">Unread: {unreadCount}</span>
        )}
      </div>
      <ul className="notifications-list">
        {notifications.map((notification) => (
          <li
            key={notification.notification_id}
            className={`notification-item ${
              notification.is_read ? 'read' : 'unread'
            }`}
            onClick={() =>
              markAsRead(
                notification.notification_id,
                notification.entity_type,
                notification.entity_id,
                notification.sender_id
              )
            }
          >
            <div className="notification-content">
              <img
                src={notification.profile_url || "/assets/images/default_profile.png"}
                alt="Sender Profile"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/profile/${notification.sender_id}`);
                }}
                className="notification-avatar"
              />
              <div className="notification-text">
                <strong>{notification.notification_text.split(" ")[0]} </strong>
                {notification.notification_text.split(" ").slice(1).join(" ")}
              </div>
            </div>

            {/* Show response buttons if it's a close friend request and pending */}
            {notification.notification_text.includes(
              "sent you a close friends request"
            ) && friendRequests[notification.entity_id] === "pending" ? (
              <div className="response-buttons">
                <button
                  className="accept-button"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleResponse(notification.entity_id, "approved");
                  }}
                >
                  Accept
                </button>
                <button
                  className="reject-button"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleResponse(notification.entity_id, "declined");
                  }}
                >
                  Reject
                </button>
              </div>
            ) : (
              !notification.is_read && <span className="unread-indicator">New</span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Notifications;